module.exports = __webpack_public_path__ + "static/media/capheight@2x.8faba65a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mozilla/DesignTokens/Typescale/capheight@2x.png
// module id = ./src/assets/Mozilla/DesignTokens/Typescale/capheight@2x.png
// module chunks = 0